// @ts-check
export default class SwishMatchInfoModel {
  /**
   * @param {import('./interface').MatchSwishA} data - api raw data
   */
  constructor(data) {
    /**
     * Match ID
     * @type {number}
     */
    this.matchID = data.m;
    /**
     * Swish match ID
     * @type {number}
     */
    this.swishMatchID = data.sm;
    /**
     * Tournament name
     * @type {string}
     */
    this.tournamentName = data.t;
    /**
     * Home team ID
     * @type {number}
     */
    this.homeTeamID = data.h;
    /**
     * Away team ID
     * @type {number}
     */
    this.awayTeamID = data.a;
  }
}